import { FbLink } from 'components/FbUI/FbLink'
import { ContactResponse } from 'models/contacts'
import { PiPencilSimpleLine, PiPhoneFill, PiEnvelopeFill } from 'react-icons/pi'
import { formatPhoneNumber } from 'utils/formatting'

type Props = {
  contact: ContactResponse
  onEdit: (contact: ContactResponse) => void
}

export function ContactCard({ contact, onEdit }: Props) {
  return (
    <div className="flex rounded-lg border border-[#E2E2E2] bg-white shadow-sm">
      <div className="flex flex-col w-full">
        <div className="flex flex-col gap-3 p-2">
          <div className="flex justify-between">
            <h2
              className="text-base text-[16px] font-semibold leading-[2em] text-[#191D23]"
              style={{ lineHeight: '2em' }}
            >
              {`${contact.first_name} ${contact.last_name}`}
            </h2>
            <button
              onClick={() => onEdit?.(contact)}
              className="flex h-6 w-6 items-center justify-center rounded bg-new-company-pistachio-light transition-colors hover:bg-gray-50"
              aria-label="Edit contact"
            >
              <PiPencilSimpleLine className="h-3.5 w-3.5 text-new-company-green-dark" />
            </button>
          </div>

          <div className="flex h-5 items-center gap-2 pb-2">
            <div className="flex items-center gap-1">
              <span
                className="text-[12px] text-gray-500 font-light leading-[1.8em] text-[#191D23]"
                style={{ lineHeight: '1.8em' }}
              >
                {contact.title} at{' '}
                <FbLink to="#" style={{ fontSize: 12 }}>
                  {contact.contact_company.name}
                </FbLink>
              </span>
            </div>
          </div>
        </div>
        <div className="flex justify-between bg-gray-50 p-2 text-[12px]">
          <div className="flex items-center gap-2">
            <PiPhoneFill />{' '}
            <FbLink style={{ fontSize: 10 }} to={`tel:${contact.phone_number}`}>
              {formatPhoneNumber({ phoneNumber: contact.phone_number })}
            </FbLink>
          </div>

          <div className="flex items-center gap-2">
            <PiEnvelopeFill />{' '}
            <FbLink
              style={{ fontSize: 10 }}
              to={`mailto:${contact.email_work}`}
            >
              {contact.email_work}
            </FbLink>
          </div>
        </div>
      </div>
    </div>
  )
}
